module.exports = __webpack_public_path__ + "img/btn_menu_ymbz.636d1abf.png";